export default __webpack_public_path__ + "static/media/greenFilledDot.da357ea9.svg";